import {
	AviaPassengerType,
	SearchParametersAirportFragment,
	SearchParametersFragment
} from '@websky/graphql';

import { ResolvedScheduleSearchParameters } from './resolveScheduleReferences';

interface BuildDefaultParametersOptions {
	departure: string;
	arrival: string;
	date: string;
	searchParameters?: ResolvedScheduleSearchParameters;
}

const resolveAirport = (
	iata: string,
	searchParameters?: ResolvedScheduleSearchParameters
): SearchParametersAirportFragment => {
	const airports =
		searchParameters?.segments
			?.filter(segment => !!segment)
			.reduce<SearchParametersAirportFragment[]>(
				(acc, segment) => [...acc, segment.departure, segment.arrival],
				[]
			) ?? [];

	return airports.find(airport => airport.iata === iata) ?? { iata, name: null, city: null };
};

export const buildDefaultParameters = ({
	departure,
	arrival,
	date,
	searchParameters
}: BuildDefaultParametersOptions): SearchParametersFragment => ({
	passengers: [
		{
			passengerType: AviaPassengerType.ADT,
			count: 1
		}
	],
	segments: [
		{
			date,
			departure: resolveAirport(departure, searchParameters),
			arrival: resolveAirport(arrival, searchParameters)
		}
	]
});
